export const SPACE_BETWEEN_THUMBS = 8;
export const LAZY_PRELOAD_IMAGES = 4;

export const TABLET_SIZE = 744;
export const IMAGE_SIZE = {
	DESKTOP: 920,
	FULL: 1920,
	THUMB: 112,
};
